module.exports = __webpack_public_path__ + "img/1489538671.79c38e33.jpg";